<app-template-text
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [maxlength]="maxlength"
  [required]="required"
  [label]="label"
  (onblur)="onblur.emit()"
/>
